(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["WISHLIST_HERO_BKP_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Mobile Search Dropdown Functionality
  document.addEventListener('DOMContentLoaded', function() {
    const searchTrigger = document.querySelector('.mobile-search-trigger');
    const searchBar = document.getElementById('mobileSearchBar');
    const closeBtn = searchBar ? searchBar.querySelector('.close-search-btn') : null;
    const searchInput = searchBar ? searchBar.querySelector('input[type="search"]') : null;
    
    if (searchTrigger && searchBar) {
      // Open search dropdown
      searchTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        searchBar.classList.add('open');
        if (searchInput) {
          setTimeout(() => searchInput.focus(), 300);
        }
      });
      
      // Close search dropdown
      if (closeBtn) {
        closeBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          searchBar.classList.remove('open');
        });
      }
      
      // Close on escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && searchBar.classList.contains('open')) {
          searchBar.classList.remove('open');
        }
      });
      
      // Close when clicking outside
      document.addEventListener('click', function(e) {
        if (searchBar.classList.contains('open') && 
            !searchBar.contains(e.target) && 
            !searchTrigger.contains(e.target)) {
          searchBar.classList.remove('open');
        }
      });
      
      // Prevent closing when clicking inside search bar
      searchBar.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    }
  });

  



  // Fixed solution for Shopify drawer menu - works with actual structure
document.addEventListener('DOMContentLoaded', function() {
  
  // Target all summary elements that have nested details (parent menus with submenus)
  const parentMenuItems = document.querySelectorAll('.menu-drawer__menu details > summary');
  
  parentMenuItems.forEach(function(summary) {
    // Check if this summary's parent has a submenu
    const parentDetails = summary.closest('details');
    const hasSubmenu = parentDetails && parentDetails.querySelector('.menu-drawer__submenu');
    
    if (!hasSubmenu) return; // Skip if no submenu
    
    // Extract the menu URL from the ID
    // Example: "HeaderDrawer-inredning" -> we need to find the corresponding link
    const summaryId = summary.getAttribute('id');
    if (!summaryId) return;
    
    // Get the text content (menu title)
    const menuTitle = summary.childNodes[0].textContent.trim();
    
    // Try to find a corresponding link in the parent menu structure
    // Look for a link with matching text in the same level or back button
    const submenuContainer = parentDetails.querySelector('.menu-drawer__submenu');
    const backButton = submenuContainer ? submenuContainer.querySelector('.menu-drawer__close-button') : null;
    
    // Get URL from the summary ID pattern or back button
    let menuUrl = null;
    
    // Method 1: Check if there's a matching direct link in the main menu
    const allLinks = document.querySelectorAll('.menu-drawer__menu a');
    for (let link of allLinks) {
      if (link.textContent.trim() === menuTitle && link.href) {
        menuUrl = link.href;
        break;
      }
    }
    
    // Method 2: Construct URL from ID (common Shopify pattern)
    if (!menuUrl && summaryId.includes('HeaderDrawer-')) {
      const handle = summaryId.replace('HeaderDrawer-', '').replace(/-/g, '-');
      // Check if this is a collection
      menuUrl = `/collections/${handle}`;
    }
    
    if (!menuUrl) return; // Skip if we can't determine the URL
    
    // Store original content
    const originalSVGs = summary.querySelectorAll('.svg-wrapper');
    
    // Clear and rebuild the summary structure
    summary.innerHTML = '';
    // summary.style.cssText = 'display: flex !important; align-items: center; justify-content: space-between;  cursor: default;';
    summary.setAttribute('data-has-submenu', 'true');
    
    // Create clickable link
    const menuLink = document.createElement('a');
    menuLink.href = menuUrl;
    menuLink.className = 'menu-drawer__menu-item-link';
    menuLink.textContent = menuTitle;
    menuLink.style.cssText = `
      flex: 1; 
      text-decoration: none; 
      color: inherit; 
      font-size: 1.6rem;
      letter-spacing: 0.06rem;
      line-height: calc(1 + 0.8 / var(--font-body-scale));
    `;
    
    // Create toggle button wrapper
    const toggleWrapper = document.createElement('span');
    toggleWrapper.className = 'menu-drawer__toggle-wrapper';
    toggleWrapper.style.cssText = 'display: flex; gap: 0.5rem; align-items: center; pointer-events: none;';
    
    // Add back the original SVG icons
    originalSVGs.forEach(svg => {
      toggleWrapper.appendChild(svg.cloneNode(true));
    });
    
    // Append elements
    summary.appendChild(menuLink);
    summary.appendChild(toggleWrapper);
    
    // Prevent summary default toggle on link click
    menuLink.addEventListener('click', function(e) {
      e.stopPropagation();
      // Allow normal link navigation
    });
    
    // Make the toggle area clickable
    summary.addEventListener('click', function(e) {
      // If clicking on the link, don't toggle
      if (e.target === menuLink || menuLink.contains(e.target)) {
        return;
      }
      
      // Otherwise, toggle the details
      e.preventDefault();
      const details = summary.closest('details');
      if (details) {
        details.open = !details.open;
      }
    });
  });
  
  console.log('Drawer menu parent links fixed - parents are now clickable');
});

// Additional CSS to ensure proper styling
const style = document.createElement('style');
style.textContent = `
  .menu-drawer__menu details > summary[data-has-submenu] {
    cursor: pointer !important;
  }
  
  .menu-drawer__menu details > summary[data-has-submenu] .menu-drawer__menu-item-link:hover {
    text-decoration: underline;
  }
  
  .menu-drawer__toggle-wrapper .svg-wrapper {
    pointer-events: none;
  }
`;
document.head.appendChild(style);
  

  } catch(e) { console.error(e); }
})();
})();
